import styled from '@emotion/styled';

import { maxWidthAndCenter } from '@styles';

const MeetTheTeamContainer = styled.div`
  ${maxWidthAndCenter}
  padding: 0 0 5rem;
  text-align: center;

  .meet_the_team__heading {
    margin: 0 0 1.5rem;
    font-size: 2rem;
    font-weight: 900;
    color: var(--orange);
    text-transform: uppercase;
  }

  .meet_the_team__grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .meet_the_team__member {
    margin: 0 0 2rem;
    text-align: center;

    .gatsby-image-wrapper {
      border-bottom: 0.5rem solid var(--orange);
      margin: 0 0 0.75rem;
    }

    h3 {
      margin: 0 0 0.5rem;
      font-size: 2rem;
      font-weight: 900;
      color: var(--blue);
      line-height: 1;
    }

    h4 {
      margin: 0 0 0.5rem;
      font-size: 1.25rem;
      font-weight: 800;
      color: var(--orange);
    }

    p {
      margin: 0 0 0.5rem;
      color: var(--blue);
    }

    p a {
      color: var(--orange);
      font-weight: bold;

      &:hover {
        text-decoration: none;
      }
    }
  }

  @media screen and (max-width: 1330px) {
    .meet_the_team__grid {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media screen and (max-width: 900px) {
    .meet_the_team__grid {
      grid-template-columns: 1fr;
    }
  }

  @media screen and (max-width: 464px) {
    img {
      width: 18rem;
    }
  }
`;

export { MeetTheTeamContainer };
